import React from 'react';
import '../../styles/ekyb.css';

const StepJurisdiction = ({ onSelect, selectedJurisdiction }) => {
  const jurisdictions = [
    {
      code: 'finland',
      name: 'Finland',
      registry: 'YTJ',
      status: 'active',
      enabled: true
    },
    {
      code: 'sweden',
      name: 'Sweden',
      registry: 'Bolagsverket',
      status: 'active',
      enabled: true
    },
    {
      code: 'denmark',
      name: 'Denmark',
      registry: 'CVR',
      status: 'active',
      enabled: true
    }
  ];

  return (
    <div className="ekyb-step-container">
      <div className="ekyb-step-header">
        <h2 className="ekyb-step-title">Select Jurisdiction</h2>
        <p className="ekyb-step-subtitle">
          Choose the country where the entity is registered. eKYB currently supports real-time verification across Nordic jurisdictions.
        </p>
      </div>

      <div className="ekyb-jurisdiction-grid">
        {jurisdictions.map((jurisdiction) => (
          <div
            key={jurisdiction.code}
            className={`ekyb-jurisdiction-card ${selectedJurisdiction === jurisdiction.code ? 'selected' : ''} ${!jurisdiction.enabled ? 'disabled' : ''}`}
            onClick={() => jurisdiction.enabled && onSelect(jurisdiction.code)}
          >
            <div className="ekyb-jurisdiction-name">{jurisdiction.name}</div>
            <div className="ekyb-jurisdiction-code">{jurisdiction.registry}</div>
            <span className={`ekyb-jurisdiction-status ${jurisdiction.status}`}>
              {jurisdiction.status === 'active' ? 'Active' : 'Coming Soon'}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepJurisdiction;
